'use client';
import type { JSX } from 'react';
import { useState } from 'react';
import { classes } from '@/utils/classes/classes';
import { SvgLoader } from '@/app/elements/svg/loader';

type AccordionProps = {
    header: string;
    body: JSX.Element | JSX.Element[] | null;
    isTopLevel?: boolean;
    handleHeaderClicked?: () => void;
    isExpandedByDefault?: boolean;
};

const Accordion = (props: AccordionProps) => {
    const { header, handleHeaderClicked, body = null, isTopLevel = false, isExpandedByDefault = true } = props;

    const [isExpanded, setIsExpanded] = useState(isExpandedByDefault);

    return (
        <div className="accordion">
            {body && (
                <button
                    onClick={() => setIsExpanded((prev) => !prev)}
                    className={classes(isTopLevel && 'top-level', isExpanded && 'expanded')}>
                    <SvgLoader iconName="arrow" />
                </button>
            )}
            <div className={classes('accordion-header', isTopLevel && 'top-level')} onClick={handleHeaderClicked}>
                {header}
            </div>
            {body && (
                <div
                    className={classes(
                        'accordion-body',
                        isTopLevel && 'top-level',
                        isExpanded ? 'expanded' : 'collapsed'
                    )}>
                    {body}
                </div>
            )}
        </div>
    );
};

export default Accordion;
